module.exports = __webpack_public_path__ + "static/media/host-session.d295fcc4.svg";